import { motion } from "framer-motion";
import HeroPanel from "@/components/HeroPanel";
import VisualPanel from "@/components/VisualPanel";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen w-full bg-[#0a0a0b] text-white/90 overflow-hidden"
    >
      {/* Ambient vignette */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(1200px 600px at 15% 10%, rgba(255,255,255,0.04), transparent 60%), radial-gradient(900px 500px at 85% 85%, rgba(255,255,255,0.03), transparent 60%)",
        }}
      />

      <div className="relative z-10 min-h-screen grid grid-cols-1 md:grid-cols-12">
        {/* LEFT — Content */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="col-span-1 md:col-span-7 flex flex-col justify-between px-6 sm:px-10 md:px-16 lg:px-24 py-10 md:py-16 lg:py-20 min-h-screen"
          data-testid="hero-section"
        >
          {/* Top bar — brand + status */}
          <div className="flex items-start justify-between">
            <div
              className="font-mono-plex text-[11px] uppercase tracking-[0.28em] text-white/60"
              data-testid="brand-mark"
            >
              <span className="text-white/90">OLS</span>
              <span className="text-white/30"> / </span>
              <span>OurLocalStories.com</span>
            </div>
            <div
              className="hidden sm:flex items-center gap-2 font-mono-plex text-[10px] uppercase tracking-[0.28em] text-white/40"
              data-testid="status-indicator"
            >
              <span className="relative inline-flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full rounded-full bg-white/70 opacity-70 animate-ping" />
                <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-white/80" />
              </span>
              MMXXVI · Est. 2026
            </div>
          </div>

          {/* Hero content */}
          <HeroPanel />

          {/* Footer */}
          <Footer />
        </motion.section>

        {/* RIGHT — Visual */}
        <VisualPanel />
      </div>
    </main>
  );
}
